import { ENDPOINT_BASE } from '@/config/endpoints'

export const ENDPOINT_POST_GET_CURRENT_USER = `${ENDPOINT_BASE}/auth/current-user`
export const ENDPOINT_POST_GET_CONNECT_TOKEN = `${ENDPOINT_BASE}/auth/connect-token`
export const ENDPOINT_POST_COMPLETE_ONBOARDING = `${ENDPOINT_BASE}/auth/onboard`
export const ENDPOINT_GET_WORKSPACES = `${ENDPOINT_BASE}/auth/workspaces`
